const generator = require('./customercredit-fullcont-multitable-generator')
const timeDate         = require ('../../../../../js-handler/time-date')



export function start(detail){  //console.log('gmt>', detail)
         
      obj[detail.act].start(detail)
}/**/


const obj = {
   
      add: { start: (detail)=>{ add(detail) }},
}

export const customercreditMT = [

	{
		tableName: "customer_credit_vs_credited_sale", 
		value:'', 
		id:'customercredit_form_customer_credit_vs_credited_sale',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'sale_id', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},
			{
				name:      'po_total_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'available_credit', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'used_credit', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},

		],

		generator: function(line){ 
			return generator.customer_credit_vs_credited_sale(line.id) 
		},

		add: function(){ 
			const newLine = generator.customer_credit_vs_credited_sale('')
			this.html.insertAdjacentHTML("beforeend", newLine) 

		} 
	},

	{
		tableName: "customer_credit_vs_paid_sale", 
		value:'', 
		id:'customercredit_form_customer_credit_vs_paid_sale',
		html:'',
		data:     [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name:      'sale_id', 
				type:      'autocomplete',
				html:      '',
				required:  true,  
			},
			{
				name:      'po_total_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'due_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
			{
				name:      'sent_amount', 
				type:      'textfield',
				html:      '',
				required:  true,  
			},
		],

		generator: function(line){ 
			return generator.customer_credit_vs_paid_sale(line.id) 
		},

		add: function(){ 
			const newLine = generator.customer_credit_vs_paid_sale('')
			//console.log("newline", newLine);
			this.html.insertAdjacentHTML("beforeend", newLine) 
		} 
	}


]